module.exports = __webpack_public_path__ + "img/foot-wechat.6fc7cea0.png";